<template>
  <tr @click="$emit('lineClick', line)">
    <td>
      <span v-if='line.is_grouping || line.group_total'>
        <span class='font-weight-bold text-uppercase' :class="line.group_total ? 'ml-8' : ''">{{ line.name }}</span>
      </span>
      <span v-else>
        <span v-if='line.grouping' class='ml-8'>
          {{ line.name }}
        </span>
        <span v-else>
          {{ line.name }}
        </span>
      </span>
    </td>
    <td align='right'>
      <span v-if='line.grouping'>
        {{ balance }}
      </span>
    </td>
    <td align='right' width='100'>
      <span v-if='!line.grouping'>
        <span v-if='line.is_grouping'></span>
        <span v-else>{{ balance }}</span>
      </span>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'balance-sheet-line',
  props: {
    line: {
      required: true
    }
  },
  computed: {
    balance () {
      return this.line.balance !== 0 ? this.$options.filters.decAccounting(this.line.balance) : '- '
    }
  }
}
</script>
